import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { Globals } from 'app/globals';
import { AssessmentsService } from 'app/services/assessment/AssessmentsService';
import { CryptoJs } from '../../shared/crypto-js/crypto-js.component';
import { ToastrService } from 'ngx-toastr';


@Component({
    selector: 'app-assessment-details',
    templateUrl: './assessmentDetails.html',
    styleUrls: ['./assessmentDetails.scss'], 
}) 
export class AssessmentDetailsComponent implements OnInit {
    assignmentId: number; 

    constructor(
        private _activatedRoute: ActivatedRoute,
        private _Globals: Globals,
        private _router: Router,
        private _AssessmentsService: AssessmentsService,
        private _CryptoJs: CryptoJs,
        private _toastr: ToastrService
    ) {
        this._activatedRoute.params.subscribe(params => {
            console.log("params", params);
            this.assignmentId = parseInt(params['assignmentId']);
            this._Globals.aResultUserType = params['userType'];
            if (this._Globals.aResultUserType === '2') {//coach
                this.getAssignmentCoachDetails();
            } else { //client
                this.getAssignmentDetails();
            }
        });
    }

    ngOnInit() {}

    getAssignmentCoachDetails() {
        this._AssessmentsService.getAssignmentCoachDetails(this.assignmentId).subscribe((data: any) => {
            console.log('response_getAssignmentCoachDetails', data);

            if (this._Globals.validationToken(data.result.Result)) {
                switch (data.result.Result) {
                    case 0:
                        this._toastr.error('We are sorry. An unexpected error happened while trying to access the request assessment.', 'ELI', {
                            disableTimeOut: true
                        });
                        this.redirectToLogin();
                        break;

                    case 1:
                        let _data = JSON.parse(this._CryptoJs.decrypt(JSON.parse(data.result.Data), 'Ps6v7y$B&E!H@McKfTjWnZq4t7w!z%8*'));
                        console.log('_data', _data);

                        this._Globals.invitacionLinkCompareIds = true;
                        this._Globals.invitationLinkUserEmail = _data.CoachEmail;
                        this._Globals.aResultCoachId = _data.CoachId;

                        if (this._Globals.getUserId() == _data.CoachId) {
                            this._router.navigate(['/app/co_a_report', this.assignmentId, 'manage_clients', 1]);
                        } else {
                            this.redirectToLogin();
                            return false;
                        }
                        break;

                    default:
                        this._toastr.error('We are sorry. An unexpected error happened while trying to access the request assessment.', 'ELI');
                        this.redirectToLogin();
                }
            } else {
                this.redirectToLogin();
                return false;
            }
        });
    }

    getAssignmentDetails() {
        this._AssessmentsService.getAssignmentDetails(this.assignmentId).subscribe((data: any) => {
            console.log('response_getAssignmentDetails', data);

            if (this._Globals.validationToken(data.result.Result)) {
                switch (data.result.Result) {
                    case -3:
                        this._toastr.warning('We are sorry. The assessment you are trying to reach has expired.', 'ELI', {
                            disableTimeOut: true
                        });
                        this.redirectToLogin();
                        break;

                    case -2:
                        this._toastr.warning('We are sorry. The assessment you are trying to reach does not exist anymore in our system. It was probably unassigned by your coach.', 'ELI', {
                            disableTimeOut: true
                        });
                        this.redirectToLogin();
                        break;

                    case 0:
                        this._toastr.error('We are sorry. An unexpected error happened while trying to access the request assessment.', 'ELI', {
                            disableTimeOut: true
                        });
                        this.redirectToLogin();
                        break;

                    case 1:
                        let _data = JSON.parse(this._CryptoJs.decrypt(JSON.parse(data.result.Data), 'Ps6v7y$B&E!H@McKfTjWnZq4t7w!z%8*'));
                        console.log('_data', _data);

                        this._Globals.invitacionLinkCompareIds = true;
                        this._Globals.invitationLinkUserEmail = _data.ClientEmail;
                        this._Globals.aResultCoachId = _data.ClientId;

                        if (this._Globals.getUserId() == _data.ClientId) {
                            this._router.navigate(['/app/c_a_report', this.assignmentId]);
                        } else {
                            this.redirectToLogin();
                            return false;
                        }
                        break;

                    default:
                        this._toastr.error('We are sorry. An unexpected error happened while trying to access the request assessment.', 'ELI', {
                            disableTimeOut: true
                        });
                        this.redirectToLogin();
                }
            } else {
                this.redirectToLogin();
                return false;
            }
        });
    }

    redirectToLogin() {
        this._Globals.deleteAllStorage();
        this._Globals.invitationLinkAssignmentId = this.assignmentId;
        this._Globals.isCoachSeeingResults = true;
        this._router.navigate(['/login']);
    }
}